import axiosInstance from '../../services/AxiosInstance';

export function getAccountInfo() {
    return axiosInstance.get(`account/accountInfo`);
}

export function getaccountloginhistoryTimeOut() {
    return axiosInstance.get(`account/LoginHistoryTimeOut`);
}
